import { c as _c } from "react/compiler-runtime";
import { sectionsCourses } from 'modules/courses/constants';
import { CourseSectionsEnum, CourseSectionsTitleEnum } from 'modules/courses/enums/course-sections-enum';
import { useRouter } from 'next/router';
import React from 'react';
import { PageTab } from 'shared/components/page-tab/page-tab';
import { PageTabGroup } from 'shared/components/page-tab/page-tab-group';
import { PageTabList } from 'shared/components/page-tab/page-tab-list';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
const TabMenu = () => {
  const $ = _c(38);
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const section = router.route;
  let t0;
  if ($[0] !== section) {
    t0 = sectionsCourses.findIndex(el => el === section);
    $[0] = section;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== router) {
    t1 = () => router.push(CourseSectionsEnum.courses);
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t(`${CourseSectionsTitleEnum.courses}`);
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <PageTab onClick={t1}>{t2}</PageTab>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== router) {
    t4 = () => router.push(CourseSectionsEnum.bundles);
    $[9] = router;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t(`${CourseSectionsTitleEnum.bundles}`);
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <PageTab onClick={t4}>{t5}</PageTab>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== router) {
    t7 = () => router.push(CourseSectionsEnum.students);
    $[16] = router;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t(`${CourseSectionsTitleEnum.students}`);
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <PageTab onClick={t7}>{t8}</PageTab>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== router) {
    t10 = () => router.push(CourseSectionsEnum.assignments);
    $[23] = router;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t(`${CourseSectionsTitleEnum.assignments}`);
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <PageTab onClick={t10}>{t11}</PageTab>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t3 || $[32] !== t6 || $[33] !== t9) {
    t13 = <PageTabList>{t3}{t6}{t9}{t12}</PageTabList>;
    $[30] = t12;
    $[31] = t3;
    $[32] = t6;
    $[33] = t9;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t0 || $[36] !== t13) {
    t14 = <PageTabGroup className="mt-[-20px]" selectedIndex={t0}>{t13}</PageTabGroup>;
    $[35] = t0;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
};
export default TabMenu;